import React from 'react';
import { TablePagination } from '@material-ui/core';

/**
 * MaterialTable still provides the deprecated onChangePage prop to
 * TablePagination, so we mirror it onto the new onPageChange prop and
 * adapt the actions component accordingly.
 */
export default function PatchedPagination(props) {
  const {
    ActionsComponent,
    onChangePage,
    onChangeRowsPerPage,
    ...tablePaginationProps
  } = props;

  const PatchedActionsComponent = ActionsComponent
    ? (subprops) => {
      const { onPageChange, ...actionsComponentProps } = subprops;
      return (
        // ActionsComponent is provided by material-table
        <ActionsComponent
          {...actionsComponentProps}
          onChangePage={onPageChange}
        />
      );
    }
    : undefined;

  return (
    <TablePagination
      {...tablePaginationProps}
      onPageChange={onChangePage}
      onRowsPerPageChange={onChangeRowsPerPage}
      ActionsComponent={PatchedActionsComponent}
    />
  );
}
